import { Carousel } from 'react-bootstrap';
import BetMatchCard from 'components/general/bet_match_card';
import BettingHistoryTitle from 'components/general/betting_history_title';
import BetBottom from 'components/general/bet_bottom';
import { EnumBetslipStatus } from '../../../toolkit/Enums';
import { getBetSlipDisplayItems } from './bettingHistoryDisplayUtils.js';

const BettingHistoryItem = ({ bettingHistoryItem }) => {
  const matchStatusTypes = ['lost', 'won', 'undecided', 'cancelled', 'cashout'];
  const displayItems = getBetSlipDisplayItems(bettingHistoryItem);
  const countForTitle = bettingHistoryItem.outcomeMap?.primaryBets
    ? Object.keys(bettingHistoryItem.outcomeMap.primaryBets).filter(
        (k) => !bettingHistoryItem.outcomeMap.primaryBets[k].isBankoBet
      ).length
    : bettingHistoryItem.matches.filter((i) => i.banker === false).length;

  return (
    <div className="shadow p-1 mx-n3" >
      <div className="px-3 fw-bold bg-gray-600" style={{backgroundColor:"#dcdcdc" }}>
        <BettingHistoryTitle
          count={countForTitle}
          betSlipType={bettingHistoryItem.betSlipType}
          betSlipStatus={bettingHistoryItem.betSlipStatus}
          combinations={bettingHistoryItem.combinations}
          numberOfBets={bettingHistoryItem.numberOfBets}
        />
      </div>
      <div className="px-3">
        <Carousel
          className="betting-history-carousel"
          variant="dark"
          indicatorLabels={displayItems.map((item) =>
            matchStatusTypes[
              bettingHistoryItem.betSlipStatus === EnumBetslipStatus.CASHOUT
                ? 4
                : item.type === 'regular'
                  ? item.match.outcomeStatus
                  : item.outcomeStatus
            ]
          )}>
          {displayItems.map((item, index1) => {
            if (item.type === 'custom') {
              return (
                <Carousel.Item key={'custom-' + index1}>
                  <BetMatchCard
                    match={item.baseMatch || item.event}
                    count={displayItems.length}
                    betSlipType={bettingHistoryItem.betSlipType}
                    customOutcomes={item.outcomeDetails}
                    customCombinedOdds={item.customOutcome?.odds}
                    customOutcomeStatus={item.outcomeStatus}
                  />
                </Carousel.Item>
              );
            }
            return (
              <Carousel.Item key={index1}>
                <BetMatchCard
                  key={'BetMatchCard' + index1}
                  match={item.match}
                  count={displayItems.length}
                  betSlipType={bettingHistoryItem.betSlipType}
                />
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
      <div className="ps-3 mt-n2">
        <BetBottom bettingHistoryItem={bettingHistoryItem} />
      </div>
    </div>
  );
};

export default BettingHistoryItem;
